/* eslint-disable camelcase */
import React from 'react';
import {
    ExternalLink,
    ExternalLinkProps,
} from '../../../bound/landingPage/PortableText';
import { addQueryParamsToUrl } from '../../../lib/url';
import { assertPresence } from '../../../lib';

export const BlogBodyExternalLink = (props: ExternalLinkProps) => {
    assertPresence(props.value);
    const utmParams = {
        utm_source: 'blog',
        utm_campaign: props.value.postSlug ?? '',
        utm_medium: 'link',
        utm_content: 'blog-content-link',
    };
    const newValue = props.value.href.includes('alude.com.br')
        ? {
              ...props.value,
              href: addQueryParamsToUrl(props.value.href, utmParams),
          }
        : props.value!;
    return <ExternalLink {...props} value={{ ...newValue, blank: true }} />;
};
